import { Component, OnInit } from '@angular/core';
import { NavBarService } from '../../../services/nav-bar.service';
import { MenuService } from '../../../services/menu.service';
import { DataIoService } from '../../../services/data-io.service';
import { MenuNode } from '../../../classes';

@Component({
  selector: 'app-lock-widget',
  templateUrl: './lock-widget.component.html',
  styleUrls: ['./lock-widget.component.scss']
})
export class LockWidgetComponent implements OnInit {

  constructor(
  	private navBar:NavBarService,
  	private menuService:MenuService,
  	private ioService:DataIoService
	) { }
  b():string{
  	return 'OFF';
  }
  handler(evt){
  	switch(evt){
  		case 'menu':{
  			this.navBar.enableAll();
  			this.navBar.blink('chimneysweep');
  			this.menuService.goto('chimneysweepmode');
        	return;
  		}
  		case 'confirm':{
  			console.log("Locking..");
  			this.ioService.getDeviceInfo().setValue('buttonlock','on');
  			this.menuService.goto('idle');
  			return;
  		}
	  	case 'back':{

	  		this.navBar.disableAll();
	  		this.menuService.goto('dashboard');
        return;
	  	}
	  	default:{
	  		return;
	  	}
  	}
  }
  subscription:any=undefined;
  ngOnDestroy(){
  	console.log("### DESTROY: lock-widget.");
  	if(this.subscription){
  		this.subscription.unsubscribe();
  	}
  }
  ngOnInit() {
  	console.log("### INIT: lock-widget.");
  	this.navBar.enableAll();
  	this.navBar.blink('locked');
  	this.subscription = this.ioService.inputs.events$.subscribe( (evt)=>{
  		this.handler(evt);
  	});
  }
}
